"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectAnnotationSummary = void 0;
const base_1 = require("./base");
class IkeObjectAnnotationSummary extends base_1.IkeRestObject {
    constructor() {
        super();
        this.className = 'AnnotationSummary';
        this.actionName = 'annotation.summary';
        this.cacheKeys['uuid'] = true;
        this.cacheKeys['revision'] = true;
        this.cacheKeys['collectionId'] = true;
    }
    updateCache(key, result, rest) {
        super.updateCache(key, result, rest);
        this.cacheIfLatest('uuid', result, rest);
        this.cacheIfLatest('revision', result, rest);
        this.cacheIfLatest('collectionId', result, rest);
    }
}
exports.IkeObjectAnnotationSummary = IkeObjectAnnotationSummary;
//# sourceMappingURL=annotation.summary.object.js.map